import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SubpageHeaderComponent } from '@components';
import { FavoriteId, HomeSectionLabel, ProductDisplayName, ProductUid, UserRoleUid } from '@constants';
import { Product, ProductService } from '@services';
import { map, Observable } from 'rxjs';
import { ProductsDirective } from '../../@shared/directives/products.directive';
import { HomeFundamentalsProductIdeasLabComponent } from './home-fundamentals-product-ideas-lab/home-fundamentals-product-ideas-lab.component';
import { HomeFundamentalsReleaseNotesComponent } from './home-fundamentals-release-notes/home-fundamentals-release-notes.component';
import { HomeFundamentalsRoadmapsComponent } from './home-fundamentals-roadmaps/home-fundamentals-roadmaps.component';
import { HomeFundamentalsStatusComponent } from './home-fundamentals-status/home-fundamentals-status.component';

@Component({
    selector: 'app-home-fundamentals',
    imports: [
        CommonModule,
        MatTooltipModule,
        MatIconModule,
        ProductsDirective,
        HomeFundamentalsRoadmapsComponent,
        HomeFundamentalsStatusComponent,
        HomeFundamentalsReleaseNotesComponent,
        HomeFundamentalsProductIdeasLabComponent,
        SubpageHeaderComponent,
    ],
    templateUrl: './home-fundamentals.component.html',
    styleUrls: ['./home-fundamentals.component.scss'],
})
export class FundamentalsComponent implements OnInit {
    private productService = inject(ProductService);
    private bo = inject(BreakpointObserver);

    /** h4 text for this section */
    title = HomeSectionLabel.FUNDAMENTALS;
    favoriteId = FavoriteId.FUNDAMENTALS;
    sectionHyperlinkLabel = 'Log in to ' + ProductDisplayName[ProductUid.GENESYS_CLOUD_CX];
    sectionHyperlinkRoute = 'https://login.mypurecloud.com/#/authenticate';

    selectedProduct$: Observable<Product>;
    productEnum = ProductUid;
    userRoleEnum = UserRoleUid;

    isMobile$: Observable<boolean>;

    ngOnInit(): void {
        this.selectedProduct$ = this.productService.selectedProduct$;
        this.isMobile$ = this.bo.observe('(max-width: 768px)').pipe(map((state) => state.matches));
    }
}
